import {isIE} from './tests';
import '../../plugins/polyfills/js/NodeList/forEach';
import 'element-closest-polyfill';

(function (UX) {
    /**
     * UX namespace for basic utils
     * @namespace
     * @type {*|{}}
     */
    UX.utils = UX.utils || {};

    /**
     * Generate unique ID suffix
     * @returns {string}
     */
    UX.utils.generateId = function () {
        // Math.random should be unique because of its seeding algorithm.
        // Convert it to base 36 (numbers + letters), and grab the first 9 characters
        // after the decimal.
        return '_' + Math.random().toString(36).substr(2, 9);
    };

    /**
     * Capitalize first letter
     * @param {string} string
     * @returns {string}
     */
    UX.utils.capitalizeFirstLetter = function (string) {
        if (typeof string == 'string') {
            return string.charAt(0).toUpperCase() + string.slice(1);
        } else {
            return '';
        }
    };

    UX.utils.fixedHeaderHeight = function (selector) {
        if (!selector) selector = '.header';
        const fixedHeader = document.querySelector(selector);
        if (!fixedHeader) return 0;

        if (fixedHeader.querySelector('.scrollThenFix')) {
            return fixedHeader.querySelector('.scrollThenFix').getBoundingClientRect().height;
        }

        if (fixedHeader.classList.contains('auto-hide-bar') || fixedHeader.querySelectorAll('.auto-hide-bar').length) {
            const fixedHeaderElements = fixedHeader.querySelectorAll('.fixed-element');
            let height = 0;
            fixedHeaderElements.forEach(element => {
                height += element.getBoundingClientRect().height;
            });
            return height;
        }

        const parentsOfHeader = fixedHeader.parentElement;

        let isFixed;
        if (isIE) {
            isFixed = fixedHeader.classList.contains('fixed') || parentsOfHeader.classList.contains('fixed');
        } else {
            const headerPositions = {
                header: window.getComputedStyle(fixedHeader).position,
                parents: window.getComputedStyle(parentsOfHeader).position,
            };
            isFixed =
                ['fixed', 'sticky'].indexOf(headerPositions.header) !== -1 ||
                ['fixed', 'sticky'].indexOf(headerPositions.parents) !== -1;
        }

        return isFixed ? fixedHeader.getBoundingClientRect().height : 0;
    };

    UX.utils.flattenAndFlip = function (object) {
        const result = {};
        for (const type in object) {
            if (!Object.prototype.hasOwnProperty.call(object, type)) continue;
            object[type].forEach(ext => (result[ext] = type));
        }
        return result;
    };

    UX.utils.getUrlParameter = function (sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

    UX.utils.removeUrlParam = function (key, sourceURL) {
        if (typeof sourceURL === 'undefined') {
            return;
        }
        let rtn = sourceURL.split('?')[0],
            param,
            params_arr = [],
            queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
        if (queryString !== '') {
            params_arr = queryString.split('&');
            for (let i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split('=')[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            rtn = rtn + '?' + params_arr.join('&');
        }
        return rtn;
    };

    UX.utils.escapeHtml = function (string) {
        var entityMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
            '`': '&#x60;',
            '=': '&#x3D;',
        };
        return String(string).replace(/[&<>"'`=\/]/g, function (s) { /*eslint-disable-line*/
            return entityMap[s];
        });
    };

    UX.utils.isRTL = () => document.querySelector('html').getAttribute('dir') === 'rtl';

    /**
     * Polyfill for document.querySelectorAll() with forEach() IE.
     * @param nodeList
     * @returns {T[]}
     */
    UX.utils.convertToArray = nodeList => Array.prototype.slice.call(nodeList);

    /**
     * To keep the focus inside the wrapper (for modal accessibility).
     * @param {HTMLElement} outerWrapper
     */
    UX.utils.focusCycle = outerWrapper => {
        if (outerWrapper) {
            /*eslint-disable*/
            const focusableList = UX.utils.convertToArray(
                outerWrapper.querySelectorAll(
                    'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
                )
            ),
                focusCycle = e => {
                    const focusOrder = e.target.dataset.focusOrder;
                    if (e.relatedTarget && !e.relatedTarget.closest('.js--focusCycle')) {
                        switch (focusOrder) {
                            case '0':
                                focusableList[focusableList.length - 1].focus();
                                break;
                            case `${focusableList.length - 1}`:
                                focusableList[0].focus();
                                break;
                        }
                    }
                };

            outerWrapper.classList.add('js--focusCycle');
            if (focusableList.length) {
                focusableList.forEach((item, index) => {
                    item.dataset.focusOrder = `${index}`;
                    item.addEventListener('focusout', focusCycle);
                });
            }
        }
    };

    UX.utils.releasedAssetsPath = () => {
        const resourcePath = [...document.querySelectorAll('link')].map(node => node.href).find(href => href.includes('releasedAssets'));
        const releasedAssetsPath = resourcePath && `${resourcePath.split('releasedAssets')[0]}releasedAssets/`;
        return releasedAssetsPath;
    };

    UX.utils.isSafari = () => {
        const excludedAgentsArray = [
            'crios',
            'fxios',
            'chrome',
            'msie',
            'rv:',
            'firefox',
            'op',
            'android',
        ];
        var userAgent = navigator.userAgent.toLowerCase();
        let isSafari =
            (userAgent.includes('iphone') || userAgent.includes('os')) &&
            (/^((?!chrome|android).)*safari/i.test(userAgent) || window.safari !== undefined);

        // Exclude other browsers
        excludedAgentsArray.forEach(agent => {
            if (userAgent.includes(agent)) {
                isSafari = false;
            }
        });
        return isSafari;
    }

    UX.utils.focusCycleInitiator = container => {
        const cycleElements = container.querySelectorAll('[class*="__cycleElement"]');
        if (!cycleElements || cycleElements.length === 0) return;
        const filteredElements = Array.from(cycleElements).filter(element => !element.closest('.hidden'));
        filteredElements.forEach((element, index) => {
            element.tabIndex = 0;
            element.addEventListener('keydown', event => {
                if (event.key === 'Tab') {
                    event.preventDefault();
                    if (event.shiftKey) {
                        const prevIndex = (index - 1 + filteredElements.length) % filteredElements.length;
                        filteredElements[prevIndex].focus();
                    } else {
                        const nextIndex = (index + 1) % filteredElements.length;
                        filteredElements[nextIndex].focus();
                    }
                }
            });
        });
    };
})(UX);

export default UX.utils;
export const { generateId, capitalizeFirstLetter, fixedHeaderHeight, flattenAndFlip, convertToArray, focusCycle } =
    UX.utils;

export const keyCodes = {
    DOWN: 40,
    END: 35,
    HOME: 36,
    LEFT: 37,
    RIGHT: 39,
    UP: 38,
    RETURN: 13,
    SPACE: 32,
    TAB: 9,
    ESCAPE: 27,
    leftClick: 0,
    ENTER: 13,
};